import React, { Fragment } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlus,
  faSyncAlt,
  faRss,
  faTrash,
  faPlusCircle
} from '@fortawesome/free-solid-svg-icons'

import {
  Row,
  Col,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Button
} from 'react-bootstrap'

import TablePagination from './TablePagination'
import { FilterSearchBar } from '../../../FilterSearchBar/FilterSearchBar'
import TableFullTextSearch from './TableFullTextSearch'

import * as Logger from 'loglevel'
import * as HubConstant from '../util/HubConstant'
import { UtilConstant } from 'hub-utilities'
import FilterBar from './FilterBar'

// import Authorize from 'components/api-authorization/AuthorizeService';

import '../../styles/TableToolbar.scss'

import { DataEditor } from '../../../DataEditor/DataEditor'
import { css } from '@emotion/core'
import ClipLoader from 'react-spinners/ClipLoader'

export const TableToolType = Object.freeze({
  FULL_TEXT_SEARCH: 0,
  MESSAGE: 1,
  SHOW_NUM_ROWS_DROPDOWN: 2,
  FILTER_SEARCH: 3,
  SYNC: 4,
  ADD: 5,
  PAGE_DISPLAY: 6,
  PAGINATION: 7,
  NEWS_FEED: 8,
  FILTER_BAR: 9,
  DELETE_SELECTED: 10,
  ADD_ROW_EDITOR: 11,
  CUSTOMIZED_BUTTON: 12
})

class TableToolbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeNodeId: props.nodeId,
      fullTextSearchText: '',
      activeNodeName: 'All',
      searchAreaFocus: HubConstant.HUB_SEARCH_AREA_FOCUS.NONE,
      editingRowIndex: -1
    }
    this.numOfRowsPerPageAvailable = [HubConstant.HUB_AUTO,5, 10, 15, 25]
    this.rowEditorRef = React.createRef()
  }

  setSearchAreaFocus = (searchAreaFocus) => {
    this.setState({
      searchAreaFocus: searchAreaFocus
    })
  }

  onHubNodesSelected = (nodes, categories) => {
    const state = {
      ...this.state,
      activeNodeId: nodes.length > 0 ? nodes[0].id : this.state.activeNodeId,
      activeNodeName:
        nodes.length > 0 ? nodes[0].name : this.state.activeNodeName
    }
    this.setState(state)
    var nodeIds = []
    for (var i = 0; i < nodes.length; i++) {
      nodeIds.push(nodes[i].id)
    }
    Logger.debug(nodeIds)

    // TODO: this line breaks:
    // this.props.setNodeFilter(nodeIds, this.props.objectType, categories, this.props.fullTextSearchText);
  }

  onOpenNewsFeed = () => {
    const rssLink = `/api/NewsFeed/content.rss`
    // rssLink += `?oauth_token=${authService.getAccessToken()}`;
    window.open(rssLink)
  }

  onSelectNumOfRowsPerPage = (selectedNum) => {
    this.props.setNumOfRowsPerPage(selectedNum)
  }

  renderDropdownItems() {
    var aryOfDropdownItems = []
    for (let i = 0; i < this.numOfRowsPerPageAvailable.length; i++) {
      aryOfDropdownItems.push(
        <Dropdown.Item
          key={this.numOfRowsPerPageAvailable[i]}
          onSelect={() => {
            this.onSelectNumOfRowsPerPage(this.numOfRowsPerPageAvailable[i])
          }}
        >
          {this.numOfRowsPerPageAvailable[i] === HubConstant.HUB_AUTO
            ? 'Auto'
            : this.numOfRowsPerPageAvailable[i]}
        </Dropdown.Item>
      )
    }
    return aryOfDropdownItems
  }

  setFullTextSearchText = (newText) => {
    this.props.setFullTextSearchText(newText)
  }

  // EditRow:
  setEditingRow = (rowIndex, onClose) => {
    if (rowIndex === this.state.editingRowIndex || !!onClose) {
      // Set editing row to none
      this.setState({ editingRowIndex: -1 })
    } else {
      this.setState({ editingRowIndex: rowIndex })
    }
  }

  displayMessage(message) {
    switch (message.type) {
      case UtilConstant.HUB_MESSAGE_TYPE.SUCCESS:
        return <p className='successMsg'>{message.message}</p>
      case UtilConstant.HUB_MESSAGE_TYPE.ERROR:
        return <p className='errorMsg'>{message.message}</p>
      default:
        return <Fragment />
    }
  }

  checkAuthority(minAuthority) {
    if (this.props.authorizeService)
      return this.props.authorizeService.getUserType() <= minAuthority
    return true // no check is needed if undefined
  }

  onFilterSetSearchAreaFocus(filters) {
    var areToFiltersEmpty = !filters
      .filter((filter) => !!filter.toFilter)
      .some((filter) => filter.toFilter.length > 0)
    var areCheckboxStatesEmpty = !filters
      .filter((filter) => !!filter.state)
      .some((filter) => filter.state !== HubConstant.HUB_CHECKBOX_STATE.EMPTY)
    if (areToFiltersEmpty && areCheckboxStatesEmpty) {
      this.setSearchAreaFocus(HubConstant.HUB_SEARCH_AREA_FOCUS.NONE)
    } else {
      this.setSearchAreaFocus(HubConstant.HUB_SEARCH_AREA_FOCUS.FILTER)
    }
  }

  onChangeFilterBar = (filters, requireAPIRefresh) => {
    // TODO: Set Search Area focus
    this.onFilterSetSearchAreaFocus(filters)
    this.props.tools
      .find((tool) => tool.action === TableToolType.FILTER_BAR)
      .onChangeFilters(filters, requireAPIRefresh)
  }

  renderButton(buttonActionEnum, buttonName, tooltipName, buttonIcon, onClick, minAuthority, permissionType) {
    const collapsibleLoaderOverride = css`
      position: relative;
      margin-top: 3%;
    `
    const buttonAction = this.props.tools.find(
      (tool) => tool.action === buttonActionEnum
    )

    // if (!!minAuthority && !this.checkAuthority(minAuthority)) return <Fragment />
      if ((this.props.dataAction === HubConstant.HUB_ACTION_STATE.ELASTIC_SEARCH) || (!!permissionType && !(!this.props.folder || ((this.props.folder && this.props.folder.folderPermissions & permissionType) === permissionType)))) return <Fragment />

    if (!!buttonAction) {
      
      if (buttonActionEnum === TableToolType.CUSTOMIZED_BUTTON
        && (buttonAction.tooltipName === undefined ||  buttonAction.buttonIcon === undefined ||buttonAction.onClick === undefined)) {
          Logger.error("For CUSTOMIZED_BUTTON, 'tooltipName', 'buttonIcon' and 'onClick' must be included in the 'tools' object declaration along with 'action'")
         return <Fragment />;
        }

        const isButtonDisabled = this.props.isFullTextSearchActive;

      return (
        this.props.isLoading ? (
          <Button
            className={`${buttonName} ${
              this.props.isLoading ? 'disabled disableClick' : ''
            }`}
            variant='dark'
            disabled={isButtonDisabled}
          >
            <ClipLoader
              size={20}
              color='#f69b1d'
              css={collapsibleLoaderOverride}
            />
          </Button>
        ) : (
          <OverlayTrigger
            placement='bottom'
            overlay={
              <Tooltip className='addButtonToolTip'>{!!tooltipName ? tooltipName : buttonAction.tooltipName}</Tooltip>
            }
          >
            <Button
              className={`refreshButton ${
                this.props.isLoading ? 'disabled disableClick' : ''
              }`}
              variant='dark'
              onClick={!!onClick ? onClick : buttonAction.onClick}
              disabled={isButtonDisabled}
            >
              <FontAwesomeIcon icon={!!buttonIcon ? buttonIcon : buttonAction.buttonIcon} />
            </Button>
          </OverlayTrigger>
        )
      )
    } else {
      return <Fragment />
    }
  }

  renderTopPart() {
    const collapsibleLoaderOverride = css`
      position: relative;
      margin-top: 3%;
    `
    if (this.props.tools) {
      return (
        <Fragment>
          <div className='TableToolbarTop'>
            {this.props.tools.some(
              (tool) => tool.action === TableToolType.FULL_TEXT_SEARCH
            ) ? (
              <Row className='structureRow slim top'>
                <Col xs='12'>
                  <TableFullTextSearch
                    fullTextSearchText={this.props.fullTextSearchText}
                    setFullTextSearchText={this.setFullTextSearchText}
                    onReloadObjects={this.props.onReloadObjects}
                    setSearchAreaFocus={this.setSearchAreaFocus}
                    searchAreaFocus={this.state.searchAreaFocus}
                    isLoading={this.props.isLoading}
                    folder={this.props.folder}
                    setActivePageName={this.props.setActivePageName}
                    isFullTextSearchActive={this.props.isFullTextSearchActive}
                    setIsFullTextSearchActive={this.props.setIsFullTextSearchActive}
                  />
                </Col>
              </Row>
            ) : (
              <Fragment />
            )}
            {this.props.tools.some(
              (tool) => tool.action === TableToolType.MESSAGE
            ) ? (
              <Row className='structureRow slim top'>
                <Col xs='12'>
                  {this.props.message
                    ? this.displayMessage(this.props.message)
                    : null}
                </Col>
              </Row>
            ) : (
              <Fragment />
            )}
            {this.props.tools.some(
              (tool) => tool.action === TableToolType.FILTER_BAR
            ) ? (
              <Row className='structureRow slim thickBottom'>
                <Col xs='12'>
                  {this.state.searchAreaFocus ===
                  HubConstant.HUB_SEARCH_AREA_FOCUS.FULL_TEXT_SEARCH ? (
                    <span className='disabled disabledMsg'>
                      Filter is disabled while performing elastic search, please
                      clear the search bar before filtering.
                    </span>
                  ) : (
                    <FilterBar
                      filters={
                        this.props.tools.find(
                          (tool) => tool.action === TableToolType.FILTER_BAR
                        ).filters
                      }
                      onChangeFilters={this.onChangeFilterBar}
                      isLoading={this.props.isLoading}
                    />
                  )}
                </Col>
              </Row>
            ) : (
              <Fragment />
            )}
            {this.props.tools.some(
              (tool) => tool.action === TableToolType.FULL_TEXT_SEARCH
            ) ||
            this.props.tools.some(
              (tool) => tool.action === TableToolType.FILTER_BAR
            ) ? (
              <Row className='partsSeparation'>
                <Col xs='12' />
              </Row>
            ) : (
              <Fragment />
            )}
          </div>
          <Row className='structureRow thickTop TableToolbarTop'>
            <Col xs='4'>
              {this.props.tools.some(
                (tool) => tool.action === TableToolType.SHOW_NUM_ROWS_DROPDOWN
              ) ? (
                <Fragment>
                  Show
                  <Dropdown className='pageDropdown'>
                    <Dropdown.Toggle variant='success' id='dropdown-basic'>
                      {this.props.numOfRowsPerPage === HubConstant.HUB_AUTO
                        ? '0'
                        : this.props.numOfRowsPerPage}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className='pageDropdownItems'>
                      {this.renderDropdownItems()}
                    </Dropdown.Menu>
                  </Dropdown>
                  {this.props.activeTableName
                    ? this.props.activeTableName.plural
                    : this.props.activePageName
                    ? this.props.activePageName.plural
                    : ''}
                </Fragment>
              ) : (
                <Fragment />
              )}
            </Col>
            <Col xs='8' className='addRefreshButtonRow'>
              {this.props.tools.some(
                (tool) => tool.action === TableToolType.DELETE_SELECTED
              ) ? (
                <OverlayTrigger
                  placement='bottom'
                  overlay={
                    <Tooltip className='addButtonToolTip'>
                      Delete Selected{' '}
                      {this.props.activeTableName
                        ? this.props.activeTableName.singular
                        : this.props.activePageName
                        ? this.props.activePageName.singular
                        : ''}
                    </Tooltip>
                  }
                >
                  <Button
                    className='addButton'
                    variant='dark'
                    onClick={() => this.props.onDeleteSelectedValues()}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </OverlayTrigger>
              ) : (
                <Fragment />
              )}
              {this.renderButton(TableToolType.ADD, 'addButton', 
                          `Add ${this.props.activeTableName
                            ? this.props.activeTableName.singular
                            : this.props.activePageName
                            ? this.props.activePageName.singular
                            : ''}`, 
                          faPlus, 
                          () => {
                            if (!this.props.isLoading) {
                              var addTool = this.props.tools.find(
                                (tool) => tool.action === TableToolType.ADD
                              )
                              if (this.props.onOpenForm) {
                                this.props.onOpenForm(
                                  addTool.form,
                                  null,
                                  addTool.data
                                )
                              } else {
                                Logger.error(
                                  'OnOpenForm(formType, objType, formObject) must be assigned as a DataTable prop for forms to display correctly!'
                                )
                              }
                            }
                          },
                          UtilConstant.HUB_USER_TYPE.HUB_USER,
                          HubConstant.USER_FOLDER_PERMISSIONS.CREATE)}
              {this.props.tools.some(
                (tool) => tool.action === TableToolType.ADD_ROW_EDITOR
              ) &&
              this.checkAuthority(UtilConstant.HUB_USER_TYPE.HUB_NODE_ADMIN) ? (
                <DataEditor
                  // TODO: Do duplicate check (migrate logic from onSubmit to duplicate check function)
                  id={0}
                  title={`Add ${
                    this.props.activeTableName
                      ? this.props.activeTableName.singular
                          .split(' ')
                          .join('\n')
                      : this.props.activePageName
                      ? this.props.activePageName.singular.split(' ').join('\n')
                      : ''
                  }`}
                  toggleIcon={faPlusCircle}
                  mediaEditInfo={
                    this.props.tools.find(
                      (tool) => tool.action === TableToolType.ADD_ROW_EDITOR
                    ).editorData
                  }
                  isActive={this.state.editingRowIndex === 0}
                  initialVal=''
                  isAddRow
                  isRightDataType={this.props.isRightDataType}
                  placement='bottom-end'
                  onToggle={this.setEditingRow}
                  onSubmit={this.props.onSubmitTableToolbarEditor}
                />
              ) : (
                // {/* <Button className="addButton" variant="dark" onClick={() => this.toggleEditingRow(0)}><FontAwesomeIcon icon={faPlus} /></Button> */}
                <Fragment />
              )}
              {this.renderButton(TableToolType.CUSTOMIZED_BUTTON, "customizedButton", null, null, null,null)}
              {this.renderButton(TableToolType.SYNC, "refreshButton", "Refresh", faSyncAlt, async () => {
                        if (!this.props.isLoading) {
                          this.props.onReloadObjects(true)
                        }
                      },null)}
              {this.props.tools.some(
                (tool) => tool.action === TableToolType.NEWS_FEED
              ) && this.checkAuthority(UtilConstant.HUB_USER_TYPE.HUB_ADMIN) ? (
                <OverlayTrigger
                  placement='bottom'
                  overlay={
                    <Tooltip className='addButtonToolTip'>
                      A Feed of {this.state.activeNodeName} Items
                    </Tooltip>
                  }
                >
                  <Button
                    className='addButton'
                    variant='dark'
                    onClick={() => this.onOpenNewsFeed()}
                  >
                    <FontAwesomeIcon icon={faRss} />
                  </Button>
                </OverlayTrigger>
              ) : (
                <Fragment />
              )}

              {this.props.tools.some(
                (tool) => tool.action === TableToolType.FILTER_SEARCH
              ) ? (
                <FilterSearchBar
                  searchText={this.props.filterSearchText}
                  setSearchText={this.props.setFilterSearchText}
                />
              ) : (
                <Fragment />
              )}
            </Col>
          </Row>
        </Fragment>
      )
    } else return <Fragment />
  }

  renderBottomPart() {
    const minPerPage =
      (this.props.currentPageNum - 1) * this.props.numOfRowsPerPage +
      (this.props.data.length > 0 ? 1 : 0)
    const maxPerPage =
      this.props.data.length >
      this.props.currentPageNum * this.props.numOfRowsPerPage
        ? this.props.currentPageNum * this.props.numOfRowsPerPage
        : this.props.data.length
    return (
      <Row className='pageNavRow'>
        <Col xs='7'>
          {!!this.props.tools &&
          this.props.tools.some(
            (tool) => tool.action === TableToolType.PAGE_DISPLAY
          ) ? (
            <div className='pagesNavigation'>
              Showing{' '}
              {minPerPage !== maxPerPage
                ? minPerPage + ' to ' + maxPerPage
                : minPerPage}{' '}
              of {this.props.data.length} in
              &nbsp;
              {this.props.activeTableName
                ? this.props.activeTableName.plural
                : this.props.activePageName
                ? this.props.activePageName.plural
                : ''}
            </div>
          ) : (
            <Fragment />
          )}
        </Col>
        <Col xs='5'>
          {!!this.props.tools &&
          this.props.tools.some(
            (tool) => tool.action === TableToolType.PAGINATION
          ) ? (
            <TablePagination
              currentPageNum={this.props.currentPageNum}
              setCurrentPageNum={this.props.setCurrentPageNum}
              maxPageNum={Math.max(
                1,
                Math.ceil(this.props.data.length / this.props.numOfRowsPerPage)
              )}
              flushNewDataCount={this.props.flushNewDataCount}
              shouldDisableCollapseAnim={this.props.shouldDisableCollapseAnim}
            />
          ) : (
            <Fragment />
          )}
        </Col>
      </Row>
    )
  }

  render() {
    return (
      <div className='TableToolbar'>
        {this.props.part === 'top' &&
        !!this.props.tools &&
        this.props.tools.some(
          (tool) =>
            tool.action === TableToolType.FULL_TEXT_SEARCH ||
            tool.action === TableToolType.MESSAGE ||
            tool.action === TableToolType.FILTER_BAR ||
            tool.action === TableToolType.SHOW_NUM_ROWS_DROPDOWN ||
            tool.action === TableToolType.ADD ||
            tool.action === TableToolType.SYNC ||
            tool.action === TableToolType.FILTER_SEARCH ||
            tool.action === TableToolType.DELETE_SELECTED ||
            tool.action === TableToolType.ADD_ROW_EDITOR
        ) ? (
          this.renderTopPart()
        ) : (
          <Fragment />
        )}
        {this.props.part === 'bottom' &&
        this.props.dataAction !== HubConstant.HUB_ACTION_STATE.LOADING &&
        !!this.props.tools &&
        this.props.tools.some(
          (tool) =>
            tool.action === TableToolType.PAGE_DISPLAY ||
            tool.action === TableToolType.PAGINATION
        ) ? (
          this.renderBottomPart()
        ) : (
          <Fragment />
        )}
      </div>
    )
  }
}

export default TableToolbar
